module.exports = __webpack_public_path__ + "img/apple-logo-w.3375a22d.svg";